function initializeArtisanPortraits(root = document) {
  root.querySelectorAll?.('.artisan-card__media:not([data-hover-ready])').forEach((portrait) => {
    portrait.dataset.hoverReady = 'true';
    const images = [...portrait.querySelectorAll('.artisan-card__image')];
    let touchIndex = 0;

    const showImage = (index) => {
      images.forEach((image, imageIndex) => {
        image.classList.toggle('artisan-card__image--active', imageIndex === index);
      });
    };

    portrait.addEventListener('pointermove', (event) => {
      if (event.pointerType === 'touch') return;
      const bounds = portrait.getBoundingClientRect();
      const position = Math.min(0.999, Math.max(0, (event.clientX - bounds.left) / bounds.width));
      showImage(Math.floor(position * Math.min(images.length, 3)));
    });

    portrait.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'touch') showImage(0);
    });

    portrait.addEventListener('click', (event) => {
      if (!window.matchMedia('(hover: none)').matches || images.length < 2) return;
      event.preventDefault();
      touchIndex = (touchIndex + 1) % Math.min(images.length, 3);
      showImage(touchIndex);
    });
  });
}

initializeArtisanPortraits();
new MutationObserver((mutations) => {
  mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) initializeArtisanPortraits(node);
  }));
}).observe(document.documentElement, { childList: true, subtree: true });
